import { labelProps } from "./types/labelProps";
import { AdditionalIcon } from "../../shared/additionalIcon/additionalIcon";

const Label = (props: labelProps) => {
    return (
        <>{AdditionalIcon(props.additionalIcon, undefined, undefined, props.secondaryFill)}<label className={props.className} style={props.style}>{props.labelname}</label></>
    );
}

export default Label;